export const ctaSection = {
  title: "Want to meet us?",
  subtitle: "Schedule a visit and discover how we can support your child's development",
  bookVisit: "Book a visit"
};
